masquerade:
  masquerade: 'Masquerade'
  masqueradeAs: Masquerade as {{ name }}
  stopMasquerading: 'Stop Masquerading'
  masqueradingAs: Masquerading as {{ name }}
  noLongerMasquerading: 'No longer masquerading'
  failedToMasquerade: 'Failed to masquerade'
crows:
  title: Crows
  tabs:
    issues: Issues
    warnings: Warnings
    good: Good
    noJob: No Job
  errorCount_one: 1 error
  errorCount_other: '{{ count }} errors'
